(() => {
  if (customElements.get('yunsho-newsletter')) return;
  const preference = 'yunsho-tea-notes';
  const session = 'yunsho-tea-notes-seen';
  const read = (storage, key) => {
    try { return JSON.parse(window[storage].getItem(key) || 'null'); } catch { return null; }
  };
  const write = (storage, key, value) => {
    try { window[storage].setItem(key, JSON.stringify(value)); } catch {}
  };
  const inViewport = node => {
    const box = node.getBoundingClientRect();
    return box.width > 0 && box.height > 0 && box.top < innerHeight && box.bottom > 0 && getComputedStyle(node).visibility !== 'hidden';
  };
  if (document.querySelector('[data-tea-notes-success="true"]')) write('localStorage', preference, { subscribed: true });
  class YunshoNewsletter extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.elapsed = 0;
      this.lastTick = Date.now();
      this.opened = false;
      this.syncViewport = () => {
        const viewport = window.visualViewport;
        const height = viewport?.height || window.innerHeight;
        const top = viewport?.offsetTop || 0;
        const bar = document.querySelector('iframe[src*="cdn.shopify.com/shopifycloud/preview-bar/"]');
        const barBox = bar?.getBoundingClientRect();
        const reserved = barBox && barBox.width && barBox.top < height && barBox.bottom >= height - 2 ? Math.min(barBox.height, height * .25) : 0;
        this.style.setProperty('--ys-viewport-height', `${Math.max(0, height - reserved)}px`);
        this.style.setProperty('--ys-viewport-top', `${top}px`);
      };
      this.syncViewport();
      window.addEventListener('resize', this.syncViewport, { signal: this.abort.signal });
      window.visualViewport?.addEventListener('resize', this.syncViewport, { signal: this.abort.signal });
      window.visualViewport?.addEventListener('scroll', this.syncViewport, { signal: this.abort.signal });
      this.closeButton = this.querySelector('.layout--close');
      this.closeButton.addEventListener('click', () => this.dismiss(), { signal: this.abort.signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.dismiss();
      }, { signal: this.abort.signal });
      this.recordSuccess = () => {
        if (document.querySelector('[data-tea-notes-success="true"]')) {
          write('localStorage', preference, { subscribed: true });
          this.setAttribute('aria-hidden', 'true');
          return true;
        }
        return false;
      };
      if (this.recordSuccess()) return;
      if (this.dataset.editor === 'true') {
        this.addEventListener('shopify:block:select', () => this.setAttribute('aria-hidden', 'false'), {signal:this.abort.signal});
        this.addEventListener('shopify:block:deselect', () => this.setAttribute('aria-hidden', 'true'), {signal:this.abort.signal});
        return;
      }
      this.tick = () => {
        const now = Date.now();
        if (!document.hidden) this.elapsed += Math.min(now - this.lastTick, 1500);
        this.lastTick = now;
        if (this.recordSuccess()) { clearInterval(this.timer); return; }
        if (this.opened) {
          this.syncViewport();
          if (this.conflict()) this.setAttribute('aria-hidden', 'true');
          else this.setAttribute('aria-hidden', 'false');
          return;
        }
        const state = read('localStorage', preference);
        if (state?.subscribed || state?.dismissedUntil > now || read('sessionStorage', session)) return;
        const distance = document.documentElement.scrollHeight - innerHeight;
        const fraction = distance > 0 ? scrollY / distance : 0;
        if (this.elapsed < Number(this.dataset.delay) * 1000 || fraction < .4 || this.conflict()) return;
        this.syncViewport();
        this.previousFocus = document.activeElement;
        this.opened = true;
        write('sessionStorage', session, true);
        this.setAttribute('aria-hidden', 'false');
      };
      this.timer = setInterval(this.tick, 1000);
    }
    conflict() {
      if (document.hidden || (!this.contains(document.activeElement) && document.activeElement?.matches('input,textarea,select'))) return true;
      if (Array.from(document.querySelectorAll('[data-yunsho-footer]')).some(inViewport)) return true;
      if (Array.from(document.querySelectorAll('form[action*="/cart/add"]')).some(inViewport)) return true;
      const selectors = ['dialog[open]', '.drawer--side[aria-expanded="true"]', '.drawer--overlay[aria-hidden="false"]', 'modal-window[aria-hidden="false"]', '[role="dialog"][aria-modal="true"]', '.x-menu--level-2--container[aria-hidden="false"]', 'popup-block[aria-hidden="false"]', '#shopify-pc__banner'];
      return selectors.some(selector => Array.from(document.querySelectorAll(selector)).some(node => {
        const box = node.getBoundingClientRect();
        return box.width > 0 && box.height > 0 && getComputedStyle(node).visibility !== 'hidden';
      }));
    }
    dismiss() {
      write('localStorage', preference, { dismissedUntil: Date.now() + Number(this.dataset.days) * 86400000 });
      this.hideForSession();
    }
    hideForSession() {
      const restore = this.contains(document.activeElement);
      write('sessionStorage', session, true);
      this.opened = false;
      this.setAttribute('aria-hidden', 'true');
      clearInterval(this.timer);
      if (restore && this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.abort?.abort();
    }
  }
  customElements.define('yunsho-newsletter', YunshoNewsletter);
})();
